export default __webpack_public_path__ + "static/media/business-bg.54f28c40.svg";